import axios from "axios"
import {env} from "../configs/EnviromentsConfigs"
const api = require('../utility/api')
const getRooms = async (dataArrvio,dataPartenza,guests,page,pageSize,week,adults,children) => {
    //console.log("get rooms")
    let body={
        "arrivalDate":parseInt(dataArrvio),
        "departureDate":parseInt(dataPartenza),
        "guests":parseInt(guests),
        "page":page,
        "pageSize":pageSize,
        "week":week,
        "adults":adults,
        "children":children
    }
    let headers ={
        headers:{
            'Content-Type': 'application/json'
        }
    }
    try {
        let response = await axios.post(env.API_ENDPOINT_URL + api.API_SEARCH_ROOMS, body, headers)
        return response
    }
    catch(error){
        return error.message
    }
}
const getWeekRooms = async (dataArrivo,dataPartenza,guests,adults,children) => {
    //console.log("getWeekRooms")
    let body={
        "arrivalDate":parseInt(dataArrivo),
        "departureDate":parseInt(dataPartenza),
        "guests":parseInt(guests),
        "week":true,
        "adults":adults,
        "children":children
    }
    let headers ={
        headers:{
            'Content-Type': 'application/json'
        }
    }
    let response = await axios.post(env.API_ENDPOINT_URL+api.API_SEARCH_ROOMS,body,headers)
    return response

}
const getRoom = async (id,dataArrvio,dataPartenza,guests,adults,children) => {
    let body={
        "arrivalDate":parseInt(dataArrvio),
        "departureDate":parseInt(dataPartenza),
        "guests":parseInt(guests),
        "adults":parseInt(adults),
        "children":parseInt(children)
    }
    let headers ={
        headers:{
            'Content-Type': 'application/json'
        }
    }
    let response = await axios.post(env.API_ENDPOINT_URL+api.API_GET_ROOM+id,body,headers)
    return response
}
const getSingleSell = async (id) => {
    let response = await axios.get(env.API_ENDPOINT_URL+api.API_GET_SINGLE_SELL+id)
    return response
}
const getAllRoom = async (page,sizePage) => {
    let endpoint =""

    if(!(page==null) && !(sizePage==null)){
        endpoint = "?page="+page+"&pageSize="+sizePage
    }
    let response = await axios.get(env.API_ENDPOINT_URL+api.API_GET_ALL_ROOM+endpoint)
    return response
}
const getFotoHome = async (component) => {

    try {

        let response = await axios.get(env.API_ENDPOINT_URL + api.API_GET_FOTO_HOME + "?component=" + component)
        return response
    }
    catch(error){
        return error.message
    }
}
const getInstaFoto = async (size) => {

    try {

        let response = await axios.get(env.API_ENDPOINT_URL + api.API_GET_INSTA_FOTO + "?size=" + size)
        return response
    }
    catch(error){
        return error.message
    }
}
const getCombo = async (dataArrivo,dataPartenza,guests) => {

    try {
        let body={
            "arrivalDate":parseInt(dataArrivo),
            "departureDate":parseInt(dataPartenza),
            "guests":parseInt(guests)
        }
        let headers ={
            headers:{
                'Content-Type': 'application/json'
            }
        }
        let response = await axios.post(env.API_ENDPOINT_URL + api.API_GET_COMBO,body,headers)
        return response
    }
    catch(error){
        return error.message
    }
}
const sendEmailContact = async (nome,email,tel,oggetto,message) => {

    try {
        let body={
            "email":email,
            "name" :nome,
            "object":oggetto,
            "number":tel,
            "message":message
        }
        let headers ={
            headers:{
                'Content-Type': 'application/json'
            }
        }
        let response = await axios.post(env.API_ENDPOINT_URL + api.API_SEND_CONTACT_EMAIL,body,headers)
        return response
    }
    catch(error){
        return error.message
    }
}
const sendEmailPren = async (nome,email,phone,arrivalDate,departureDate,prezzo,appartamento,adults,children,roomId,messaggio,notes) => {

    try {
        let body={
            "email":email,
            "name" :nome,
            "telefono":phone,
            "arrivalDate":arrivalDate,
            "departureDate":departureDate,
            "prezzo":prezzo,
            "appartamento":appartamento,
            "adults":adults,
            "children":children,
            "roomId":roomId,
            "messaggio":messaggio,
            "notes":notes

        }
        let headers ={
            headers:{
                'Content-Type': 'application/json'
            }
        }
        let response = await axios.post(env.API_ENDPOINT_URL + api.API_SEND_CONTACT_EMAIL_PREN,body,headers)
        return response
    }
    catch(error){
        return error.message
    }
}

const getroomSell = async () => {

    try {
        let response = await axios.get(env.API_ENDPOINT_URL + api.API_GET_SELL)
        return response
    }
    catch(error){
        return error.message
    }
}
const getPromotion = async () => {

    try {
        let response = await axios.get(env.API_ENDPOINT_URL + api.API_GET_PROMOTION)
        return response
    }
    catch(error){
        return error.message
    }
}
const getCityFromLatLng = async (lat,lng) => {
    let input=lat+','+lng
    try {
        let response = await axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng="+input+"&key="+env.API_KEY_GOOGLE)
        return response
    }
    catch(error){
        return error.message
    }
}
const callMultipleAxios = async (allAxios,callback) =>{
    console.log("multiple axios",allAxios)
    Promise.all(allAxios).then(function (response) {
        console.log("dentro allAxios");
        console.log(response);
        callback(response)
    }).catch(err => {
        console.log(err);
    })

}


export {
    getRooms,
    getRoom,
    getWeekRooms,
    callMultipleAxios,
    getAllRoom,
    getFotoHome,
    getInstaFoto,
    getCombo,
    sendEmailContact,
    getroomSell,
    getSingleSell,
    getPromotion,
    getCityFromLatLng,
    sendEmailPren
}